import React from 'react';
import styles from './bottom.module.css';
import ArrowRight from '../../../assets/images/arrow_right.png';
import ArrowLeft from '../../../assets/images/arrow_left.png';
import ArrowUp from '../../../assets/images/arrow_up.png';
import ArrowDown from '../../../assets/images/arrow_down.png';

function Bottom({left, right}) {
  const {bottomManual, bottomLeft, bottomRight, arrowRight, arrowLeft, upDown, arrowUp, arrowDown} =
    styles;

  return (
    <div className={bottomManual}>
      {left && <img className={arrowLeft} src={ArrowLeft} alt="Left" />}
      <span className={bottomLeft}>{left}</span>
      <div style={{flex: 1}} />

      <span className={bottomRight}>{right}</span>
      {right && <img className={arrowRight} src={ArrowRight} alt="Right" />}
    </div>
    //  <div className={upDown}>
    //   <img className={arrowUp} src={ArrowUp} alt="Up" />
    //   <img className={arrowDown} src={ArrowDown} alt="Down" />
    // </div>
  );
}

export default Bottom;
